import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
	labelName: any = {
		client_name: '',
		client_address_1: 'Address 1',
		client_pincode: 'Pincode',
		voyage_name: 'Voyage Name',
		mode_of_shipment: 'Mode of Shipment',
		coverage_type: 'Coverage Type',
		packing: 'Packing',
		from_country: 'From Country',
		to_country: 'To Country',
		from_city: 'From City',
		to_city: 'To City',
		invoice_currency: 'Invoice Currency Type',
		cargo_value: 'Cargo Value',
		roe: 'Rate of Exchange',
		cargo_si: 'Cargo Sum Insured',
		duty_si: 'Duty Sum Insured',
		marine_final_rate_percentage: 'Marine Final Rate',
		cargo_si_policy_currency: 'Cargo Sum Insured Value',
		total_si: 'Total Sum Insured',
		cargo_premium: 'Cargo Premium',
		duty_premium: 'Duty Premium',
		total_premium: 'Total Premium',
		gst: 'GST',
		net_premium_final: 'Net Premium',
		non_std_clause: 'Non-Standard Clauses',
		expected_date_shipment: 'Expected Date of Shipment',
		bill_no: 'Bill of Lading / Airway Bill Number',
		bill_date: 'Bill of Lading / Airway Bill Date',
		lc_no: 'Letter of Credit Number',
		issuance_place: 'Place of issuance',
		invoice_no: 'Invoice Number',
		invoice_date: 'Invoice Date',
		vessel_name: 'Vessel name of Flight Number / Airline',
		consignee_name: 'Consignee Name',
		consignee_address: 'Consignee address',
		financier_name: 'Financier Name',
		issue_date: 'Issue Date',
		lc_details: 'Letter of Credit Description & Special Terms',
		subject_matter_insured: 'Subject Matter Insured',
		marks_numbers: 'Marks & Numbers',
		claims_payable_at: 'Claims payable at',
		settling_agent: 'Settling Agent',
		claims_rep: 'Claims Representative',
		from_date: 'From Date',
		total_sales: 'Total sales / invoice value',
		file: 'Upload Your file'
	};
	constructor() { }

	static getValidatorErrorMessage(validatorName: string) {
		let config = {
			'required': 'Required * ',
			// [validatorName]: `Please enter ${labelName[validatorName]}`
			'file_extension': 'Please upload only these files (excel, word, pdf, image, zip)',
			'cert_draft_no_invalid': 'Enter draft/certificate no is not pertaining to same voyage',
			'file_size': 'Upload document must be upto 5MB',
			'pincode_invalid': 'Entered Pincode is Invalid',
			'invalidData': 'Invalid Data'
		};
		return config[validatorName];
		// return null;
	}

	static checkNumeric(control) {
		if (control.value.match(/^[0-9]*$/)) {
			return null;
		} else {
			return { 'invalidData': true };
		}
	}

	fieldValidation(formFieldsValue)
	{
		let returnErrorArray = [];

		for (let propertyName in formFieldsValue)
		{
			let splChars = "126,96,33,64,35,36,37,94,38,42,40,41,45,95,43,61,123,125,91,93,124,92,47,58,59,34,39,60,61,44,46,63,32";
			let splCharCount = 0;
			let flag = 0;
			let fieldName = '';
			let fieldValue = '';
			fieldName = propertyName;
			fieldValue = formFieldsValue[propertyName].trim();

			if(fieldName.indexOf('File') < 0 && fieldName.indexOf('emailId') < 0)
			{
				if(fieldValue != '')
				{
					for(let count = 0; count < fieldValue.length; count++ )
					{
						let strAscii = fieldValue.charCodeAt(count).toString();

						if(fieldValue[count] == fieldValue[0])
							flag++;
						if(splChars.indexOf(strAscii) > -1)
							splCharCount++;
					}
				}

				if(formFieldsValue[propertyName].length > 0 )
				{
					if(fieldName == "countryCode" || fieldName == "settling_Agent_Code")
					{
						if(((flag == fieldValue.length && flag > 3) || fieldValue == ""  || splCharCount == fieldValue.length) || (fieldValue == "0" || fieldValue == "00" || fieldValue == "000"))
						{
							returnErrorArray.push(fieldName);
						}
						/* if((flag == fieldValue.length && flag > 3) || fieldValue == ""  || splCharCount == fieldValue.length)
						{
							returnErrorArray.push(fieldName);
						}
						else if(fieldValue == "0" || fieldValue == "00" || fieldValue == "000")
						{
							returnErrorArray.push(fieldName);
						} */
					}
					else
					{
						if(flag == fieldValue.length || splCharCount == fieldValue.length)
						{
							returnErrorArray.push(fieldName);
						}
					}
				}
			}
		}
		return { 'fieldName':returnErrorArray, "error":true };
	}
  
}
